import { EventType } from "../balancing/types/BalancingCore";
export var IdTournamentCategory;
(function (IdTournamentCategory) {
    IdTournamentCategory[IdTournamentCategory["LeagueOverview"] = 41] = "LeagueOverview";
    IdTournamentCategory[IdTournamentCategory["PlayerLeague"] = 42] = "PlayerLeague";
    IdTournamentCategory[IdTournamentCategory["LeagueRanking"] = 43] = "LeagueRanking";
    IdTournamentCategory[IdTournamentCategory["CoopLeague"] = 44] = "CoopLeague";
    // sub-categories... they are indexed as categories in balancing, in order to be the same
    // with mobile, which does not use categories.
    IdTournamentCategory[IdTournamentCategory["playerLeagueRewards"] = 52] = "playerLeagueRewards";
    IdTournamentCategory[IdTournamentCategory["collectLeagueRewards"] = 54] = "collectLeagueRewards";
    IdTournamentCategory[IdTournamentCategory["coopLeagueRewards"] = 53] = "coopLeagueRewards";
})(IdTournamentCategory || (IdTournamentCategory = {}));
export var mapEventTypeToSpecialCategories = new Map([
    [EventType.CollectLeague, IdTournamentCategory.collectLeagueRewards],
    [EventType.PlayerLeague, IdTournamentCategory.playerLeagueRewards],
    [EventType.CoopLeague, IdTournamentCategory.coopLeagueRewards],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/IdTournamentCategory.ts
// module id = 300
// module chunks = 3